<div class="panel-header" (click)="toggle($event)">
    <div class="panel-header_title">
        <ng-content></ng-content>
    </div>
    <span class="arrow"></span>
</div>